
export default {
    api: {
        url: process.env.STAG_URL,
        mode: 'cors'
    },
}
